import { render, staticRenderFns } from "./SbsTree.vue?vue&type=template&id=30ffe80e&scoped=true"
import script from "./SbsTree.vue?vue&type=script&lang=js"
export * from "./SbsTree.vue?vue&type=script&lang=js"
import style0 from "./SbsTree.vue?vue&type=style&index=0&id=30ffe80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ffe80e",
  null
  
)

export default component.exports